import * as React from 'react'
import { LIGHT_GRAY } from '@omnilert/components'

/**
 * Renders a small circular dot SVG icon
 * @param {object} props - Component props
 * @param {string} props.className - CSS class name for the SVG element
 * @returns {JSX.Element} Dot icon SVG element
 */
function Dot(props) {
  const { className } = props
  return (
    <svg
      className={className}
      fill='none'
      height={8}
      viewBox='0 0 9 8'
      width={9}
    >
      <circle
        cx={4.2}
        cy={4}
        fill={LIGHT_GRAY}
        r={4}
      />
    </svg>
  )
}

export default Dot
